"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DomainRxEventHandler {
    constructor(category, logger, evtHub) {
        this._subscriptions = [];
        this._category = category;
        this._logger = logger;
        this._evtHub = evtHub;
    }
    registerEventHandler(evtName, syncHandler) {
        const sub = this._evtHub.subscribeEventHandler(this._category, evtName, syncHandler, (error) => this.OnError(evtName, error));
        this._subscriptions.push(sub);
    }
    registerAsyncEventHandler(evtName, asyncHandler) {
        const sub = this._evtHub.subscribeEventAsyncHandler(this._category, evtName, asyncHandler, (error) => this.OnError(evtName, error));
        this._subscriptions.push(sub);
    }
    handleEvent(e) {
        throw new Error("Not Implemented.");
    }
    handleEventAsync(e) {
        throw new Error("Not Implemented.");
    }
    OnError(evtName, error) {
        //處理呼叫EventHandler從EventHub報回來的Exception，可以往外發出去
        this._logger.error(`Handler event ${this._category}.${evtName} error: ${error.message}`, error);
    }
}
exports.DomainRxEventHandler = DomainRxEventHandler;
//# sourceMappingURL=DomainRxEventHandler.js.map